module.exports = __webpack_public_path__ + "img/media-5.4294b36f.jpg";